import LazyLoad from "vanilla-lazyload/dist/lazyload.js";

let videosPage = 2;
const $loadMoreBtn = $('.videos-load_more');
const videosMoreUrlPath = $loadMoreBtn.attr('data-url');

let lazyLoad;

function loadMoreVideos(event) {
    event.preventDefault();

    if ($loadMoreBtn.is(':disabled')) {
        return;
    }
    $loadMoreBtn.attr('disabled', true);

    getVideos(videosPage);
}

function getVideos(page) {
    axios.get('/'+videosMoreUrlPath, {
        params: {
            page: page
        }
    }).then(function (response) {
        $('.videos-grid').append(response.data.response);

        if (page > 1) {
            $('html,body').animate({scrollTop: '+=600px'}, 600);
        }
        videosPage++;
        if (response.data.lastPage) {
            $loadMoreBtn.hide(0);
        }

        $loadMoreBtn.attr('disabled', false);
        lazyLoad.update();
    }).catch(function (error) {
        console.log('Videos could not be loaded.');
    });
}

$(function () {
    if ($('.videos-grid_item').length) {
        lazyLoad = new LazyLoad({
            elements_selector: '.lazy',
        });
    }

    $(document).on('click', '.videos-grid_item', event => {
        if(!window.cc.allowedCategory('targeting')) {
            $('.cookie-alert .cookie-alert_header').addClass('video');
            $('.cookie-alert').fadeIn();
            return;
        }


        let $item = $(event.currentTarget);
        let youtubeID = $item.attr("data-youtube-id");

        $item.find('.aspect-ratio').find('img').fadeOut(400, () =>  {
            $item.find('.aspect-ratio').append(`<iframe src="https://www.youtube.com/embed/${youtubeID}?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`).hide().fadeIn(400);
        });

        trackPageView($item.find('.videos-grid_item-title').text());
    });

    $(document).on('click', '.videos-load_more', loadMoreVideos);
});
